import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { POSTS } from "@/data/blog";

export default function BlogIndex() {
  return (
    <div className="bg-background min-h-screen" data-testid="blog-index">
      <Seo
        title="Guides & Fan Gear Tips | Jersey Blend"
        description="Guides for custom fan gear: World Cup hoodies, gift ideas for NBA fans, NFL game day style, and how to personalize your jersey with your name and number."
        keywords="custom World Cup hoodies, gift ideas for NBA fans, custom NFL hoodie, custom hoodie with name, fan gear guides"
        path="/blog"
      />
      <div className="px-6 md:px-12 lg:px-16 pt-16 pb-10 border-b border-white/10">
        <p className="text-xs uppercase tracking-[0.3em] font-bold text-primary mb-4">Guides</p>
        <h1 className="font-anton text-4xl sm:text-5xl lg:text-6xl uppercase leading-none text-white">
          Fan Gear Guides & Tips
        </h1>
        <p className="text-white/60 mt-6 leading-relaxed max-w-2xl text-base">
          Ideas and how-tos for building custom hoodies and tees you'll actually wear — from World Cup kits to game-day gifts.
        </p>
      </div>
      <div className="px-6 md:px-12 lg:px-16 py-12 grid gap-6 md:grid-cols-2 lg:grid-cols-2">
        {POSTS.map((post) => (
          <Link
            key={post.slug}
            to={`/blog/${post.slug}`}
            data-testid={`blog-card-${post.slug}`}
            className="group block border border-white/10 bg-card hover:border-primary transition-colors overflow-hidden"
          >
            <div className="aspect-[16/9] overflow-hidden bg-neutral-900">
              <img src={post.hero} alt={post.title} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" />
            </div>
            <div className="p-6">
              <h2 className="font-anton text-xl sm:text-2xl uppercase tracking-tight leading-tight text-white group-hover:text-primary transition-colors">
                {post.title}
              </h2>
              <p className="text-white/60 mt-3 text-sm leading-relaxed">{post.excerpt}</p>
              <span className="inline-flex items-center gap-2 mt-4 text-xs uppercase tracking-[0.15em] font-bold text-primary">
                Read guide <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
